/**
 * Reads Nest-style `{ message: string | string[] }` from a failed Response.
 * Falls back to `fallback` when body is empty/unreadable.
 */
export async function parseApiErrorMessage(response: Response, fallback: string): Promise<string> {
  try {
    const errBody = (await response.json()) as { message?: string | string[] };
    const raw = errBody?.message;
    if (typeof raw === 'string' && raw.trim()) {
      return raw;
    }
    if (Array.isArray(raw) && raw[0]) {
      return String(raw[0]);
    }
  } catch {
    // keep fallback
  }
  return fallback;
}
